import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { ISectionProps, Section } from "@/components/Section";
import { IDesignatedCandidate } from "@/data/job-requests";
import { formatPhone } from "@/data/phones";
import { Col, Row } from "@/eworkitComponents";
import { JobRequestDetailIconSection } from "@/views/JobRequests/Detail/components";

export interface IDesignatedCandidateProps extends ISectionProps {
  designatedCandidate: IDesignatedCandidate;
}

export const DesignatedCandidate: FC<IDesignatedCandidateProps> = memo(({ designatedCandidate, ...props }) => {
  const { t } = useTranslation("public");

  return (
    <Section width={12} padding={["md", "lg"]} borderRadius {...props}>
      <Header weight="bold" size="sm">
        {t("DESIGNATED_CANDIDATE.HEADER")}
      </Header>

      <Row margin={["md", false, false, false]}>
        <Col width={{ xxs: 12, sm: 6 }}>
          <JobRequestDetailIconSection
            label={t("DESIGNATED_CANDIDATE.LABEL_CANDIDATE_NAME")}
            value={designatedCandidate.workerName}
            icon="user"
          />
        </Col>

        <Col width={{ xxs: 12, sm: 6 }}>
          <JobRequestDetailIconSection
            label={t("DESIGNATED_CANDIDATE.LABEL_CONTACT_PERSON")}
            value={
              <>
                {designatedCandidate.companyContactPerson}
                <br />
                {formatPhone(designatedCandidate.companyPhoneNumber)}
                <br />
                {designatedCandidate.companyEmail}
              </>
            }
            icon="phone"
          />
        </Col>
      </Row>
    </Section>
  );
});
